import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue'),
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services.vue'),
    children: [
      {
        path: '', // 不填 預設page下一進來就是帶入卡片1
        name: 'services1',
        component: () => import('../views/services_page1.vue'),
      },
      {
        path: '/services/forsomeone2',
        name: 'services2',
        component: () => import('../views/services_page2.vue'),
      },
      {
        path: '/services/forsomeone3',
        name: 'services3',
        component: () => import('../views/services_page3.vue'),
      },
      {
        path: '/services/forsomeone4',
        name: 'services4',
        component: () => import('../views/services_page4.vue'),
      },
    ],
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue'),
  },
  {
    path: '/contactus',
    name: 'Contactus',
    component: () => import('../views/Contactus.vue'),
  },
];

const router = new VueRouter({
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'activee',
});

export default router;
